import React from "react";
import { AddressAction } from "../../../actions/Address";
import { VendorAction } from "../../../actions/vendor";
import { SiteAction } from "../../../actions/site";
import {
  gpsStatus,
  loadStatus,
  runningStatus,
  vehicleDeviceStatus,
} from "../../../dropdownList/dropdownList";
import { RouteAction } from "../../../actions/route";
import { PermissionAction } from "../../../actions/permission";
import { UserAction } from "../../../actions/user";
import { useSnackbar } from "../SnackbarProvider";
import { snakeCase } from "lodash";
import { Snackbar } from "@material-ui/core";
import { VehicleAction } from "../../../actions/vehicle";
import {
  loadDecryptedSession,
  saveEncryptedSession,
} from "../SessionStorageHelper/SessionStorage";

function useApiFetch() {
  const { showSnackbar } = useSnackbar();
  const userData = JSON.parse(sessionStorage.getItem("data")) || {};
  const siteIds = userData?.sites?.map((s) => s.id) || [];

  const fetchCategoryWiseList = (response) => {
    const categorized = response;
    // Access like this:

    // const loadingPoints = categorized.LOADING || [];
    // const unLoadingPoints = categorized.UNLOADING || [];
    const areaList = categorized.AREA || [];
    const yardList = categorized.YARD || [];
    const regionList = categorized.REGION || [];
    const mineList = categorized.MINE || [];
    const hybridList = categorized.HYBRID || [];
    const boundaryList = categorized.BOUNDARY || [];
    const routeList = categorized.ROUTE || [];
    const areaMineList = [
      ...(categorized.AREA || []),
      ...(categorized.MINE || []), // ✅ HYBRID merged into LOADING
    ];
    const loadingPoints = [
      ...(categorized.LOADING || []),
      ...(categorized.HYBRID || []), // ✅ HYBRID merged into LOADING
    ];
    const unLoadingPoints = [
      ...(categorized.UNLOADING || []),
      ...(categorized.HYBRID || []), // ✅ HYBRID merged into LOADING
    ];

    return {
      loadingPoints,
      unLoadingPoints,
      areaList,
      yardList,
      regionList,
      mineList,
      hybridList,
      boundaryList,
      routeList,
      areaMineList,
    };
  };
  const fetchSiteList = async (
    setSiteList,
    setCategoryWiseList,
    setOpreationList,
    refresh,
  ) => {
    const siteDTOList = loadDecryptedSession("siteDTOList") || [];
    if (siteDTOList.length > 0) {
      const categories = [
        "AREA",
        "MINE",
        "LOADING",
        "UNLOADING",
        "YARD",
        "REGION",
        "HYBRID",
        "BOUNDARY",
        "ROUTE",
      ];
      const categorizeSites =
        siteDTOList &&
        siteDTOList?.reduce((acc, site) => {
          if (categories.includes(site.siteCategory)) {
            if (!acc[site.siteCategory]) acc[site.siteCategory] = [];
            acc[site.siteCategory].push(site);
          }
          return acc;
        }, {});
      setCategoryWiseList(fetchCategoryWiseList(categorizeSites));
      if (typeof setOpreationList === "function") {
        setOpreationList({
          mineList: fetchCategoryWiseList(categorizeSites)?.mineList,
          loadingList: fetchCategoryWiseList(categorizeSites)?.loadingPoints,
          unLoadingList:
            fetchCategoryWiseList(categorizeSites)?.unLoadingPoints,
        });
      }
    } else {
      await SiteAction.fetchSiteRouteSubSite(
        {
          companyId: userData.companyId,
          showSubSite: true,
          showRoute: true,
        },
        showSnackbar,
      ).then((response) => {
        if (response != null) {
          setSiteList(response?.siteDTOList || []);
          saveEncryptedSession("siteDTOList", response?.siteDTOList);
          const categories = [
            "AREA",
            "MINE",
            "LOADING",
            "UNLOADING",
            "YARD",
            "REGION",
            "HYBRID",
            "BOUNDARY",
            "ROUTE",
          ];
          const categorizeSites =
            response?.siteDTOList &&
            response?.siteDTOList?.reduce((acc, site) => {
              if (categories.includes(site.siteCategory)) {
                if (!acc[site.siteCategory]) acc[site.siteCategory] = [];
                acc[site.siteCategory].push(site);
              }
              return acc;
            }, {});

          setCategoryWiseList(fetchCategoryWiseList(categorizeSites));
          if (typeof setOpreationList === "function") {
            setOpreationList({
              mineList: fetchCategoryWiseList(categorizeSites)?.mineList,
              loadingList:
                fetchCategoryWiseList(categorizeSites)?.loadingPoints,
              unLoadingList:
                fetchCategoryWiseList(categorizeSites)?.unLoadingPoints,
            });
          }
        } else {
          setSiteList([]);
          setOpreationList({
            mineList: [],
            loadingList: [],
            unLoadingList: [],
          });
        }
      });
    }
  };

  const fetchVendorList = async (setVhicleList) => {
    await VendorAction.fetchVendorList(
      {
        pageNo: 0,
        pageSize: 1000,
        companyId: userData?.companyId,
        companyName: "",
        isActive: "",
        name: "",
        siteIds: siteIds,
        userId: userData?.id,
      },
      showSnackbar,
    ).then((response) => {
      if (response != null) {
        setVhicleList(response?.data);
      } else {
        setVhicleList([]);
      }
    });
  };

  const fetchVehicleListold = async (setVendorList, setOldVehicleList) => {
    await VehicleAction.fetchVehicleList(
      {
        pageNo: 0,
        pageSize: 0,
        companyId: userData?.companyId,
        number: "",
        vehicleType: "",
        driver: "",
        siteId: "",
        siteIds: siteIds,
        userId: userData?.id,
        onlyGpsVehicle: true,
        forDropDown: false,
      },
      showSnackbar,
    ).then((response) => {
      if (response != null) {
        setVendorList(response);
        if (typeof setOldVehicleList === "function") {
          setOldVehicleList(response);
        }
      } else {
        setVendorList([]);
      }
    });
  };

  const fetchVehicleList = async (setVendorList, setOldVehicleList) => {
    await VehicleAction.fetchVehicleListDropdown(
      {
        onlyGpsVehicle: true,
      },
      showSnackbar,
    ).then((response) => {
      if (response != null) {
        console.log("vehicleresp", response);
        setVendorList(response?.data);
        if (typeof setOldVehicleList === "function") {
          setOldVehicleList(response?.data);
        }
      } else {
        setVendorList([]);
      }
    });
  };
  const fetchVehicleType = async (setVeVehicleTypeList) => {
    await VehicleAction.vehicleTypeList(showSnackbar).then((response) => {
      debugger;
      if (response != null) {
        setVeVehicleTypeList(response);
      } else {
        setVeVehicleTypeList([]);
      }
    });
  };

  const fetchRouteList = async (setRouteList) => {
    await RouteAction.fetchRouteList({
      pageNo: 0,
      pageSize: "",
      companyId: userData?.companyId,
      destination: "",
      source: "",
      name: "",
      siteIds: siteIds,
      userId: userData?.id,
    }).then((response) => {
      if (response != null) {
        setRouteList(response);
      } else {
        setRouteList([]);
      }
    });
  };
  const fetchPermissionList = async (setPermissionList) => {
    await PermissionAction.fetchPermissionListForAudit().then((response) => {
      if (response != null) {
        setPermissionList(response.data);
      } else {
        setPermissionList([]);
      }
    });
  };

  const fetchUserList = (setUserList) => {
    UserAction.fetchUserList({
      pageNo: 0,
      pageSize: "",
      companyId: JSON.parse(sessionStorage.getItem("data")).companyId,
      employeeCode: "",
      siteId: "",
      name: "",
    }).then((response) => {
      debugger;
      if (response != null) {
        setUserList(response);
      } else {
        setUserList([]);
      }
    });
  };
  // const getvehicleDeviceStatus = () => {
  //   return vehicleDeviceStatus;
  // };
  // const getGpsStatus = () => {
  //   return gpsStatus;
  // };
  // const getrunningStatus = () => {
  //   return runningStatus;
  // };
  // const getloadStatus = () => {
  //   return loadStatus;
  // };

  return {
    fetchVehicleList,
    fetchVendorList,
    fetchSiteList,
    fetchRouteList,
    fetchPermissionList,
    fetchUserList,
    fetchVehicleType,
    fetchVehicleListold,
    // getvehicleDeviceStatus,
    // getGpsStatus,
    // getloadStatus,
  };
}

export default useApiFetch;

// Utility to categorize sites dynamically
